import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import saveAs from 'file-saver';
import moment from 'moment';
import { ThawiProvider } from '../../shared/nestjs/payroll/50thawi/50thawi';
import { BankReportProvider } from '../../shared/nestjs/payroll/bank-report/bank-report';
import { BanKThaiReportProvider } from '../../shared/nestjs/payroll/bank-thai-report/bank-thai-report';
import { BpjsReportProvider } from '../../shared/nestjs/payroll/bpjs-report/bpjs-report';
import { CostCenterThaiProvider } from '../../shared/nestjs/payroll/costCenterThai/cost.center.thai';
import { FileTransferProvider } from '../../shared/nestjs/payroll/file-transfer/file-transfer';
import { PayrollHistoryProvider } from '../../shared/nestjs/payroll/payroll-history/payroll-history-provider';
import { PayrollInsuranceReportProvider } from '../../shared/nestjs/payroll/payroll-insurance-report/payroll-insurance-report';
import { PayrollProcessReportProvider } from '../../shared/nestjs/payroll/payroll-process-report/payroll-process-report';
import { PayrollProcessThaiReportProvider } from '../../shared/nestjs/payroll/payroll-process-thai-report/payroll-process-thai-report';
import { PayrollRegisterReportProvider } from '../../shared/nestjs/payroll/payroll-register-report/payroll-register-report';
import { PayrollSptReportProvider } from '../../shared/nestjs/payroll/payroll-spt-report/payroll-spt-report';
import { PayrollTaxReportProvider } from '../../shared/nestjs/payroll/payroll-tax-report/payroll-tax-report';
import { Pnd1Provider } from '../../shared/nestjs/payroll/pnd1/pnd1';
import { Pnd1korProvider } from '../../shared/nestjs/payroll/pnd1kor/pnd1kor';
import { Pnd91Api } from '../../shared/nestjs/payroll/pnd91.api';
import { ReportLoryorApi } from '../../shared/nestjs/payroll/report-loryor.api';
import { SfCompanyProvider } from '../../shared/nestjs/payroll/sf-company/sf-company';
import { SfPayslipProvider } from '../../shared/nestjs/payroll/sf-payslip/sf-payslip';
import { WorkmenReportProvider } from '../../shared/nestjs/payroll/workmen-report/workmen-report';
import { LoopBackAuth, LoopBackConfig } from '../../shared/sdk';
import { AlertServiceProvider } from '../alert-service/alert-service';
import { PayrollProcessMalayReportApi } from '../../shared/nestjs/payroll/payroll-process-malay-report.api';
import { StdFormulaReportApi } from '../../shared/nestjs/payroll/std-formula-report.api';
import { RequestDownloadFormulaDto } from '../../shared/nestjs/payroll/std-formula-report.dto';
import { BankMalayReportApi } from '../../shared/nestjs/payroll/bank-malay-report.api';
import { FileDownloaderProvider } from '../file-downloader/file-downloader';
import { RequestExportSocsoPDF } from '../../shared/nestjs/payroll/socso-report.dto';
import { SocsoReportApi } from '../../shared/nestjs/payroll/socso-report.api';

export enum Extension {
  PDF = 'pdf',
  WORD = 'docx',
  EXCEL = 'xlsx',
  CSV = 'csv',
  TEXT = 'txt',
  ZIP = 'zip',
}

@Injectable()
export class GdPayrollReportProvider {

  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private http: HttpClient,
    private alertService: AlertServiceProvider,
    private payrollProcessReportProvider: PayrollProcessReportProvider,
    private payrollTaxReportProvider: PayrollTaxReportProvider,
    private bankReportProvider: BankReportProvider,
    private bpjsReportProvider: BpjsReportProvider,
    private payrollSptReportProvider: PayrollSptReportProvider,
    private payrollRegisterReportProvider: PayrollRegisterReportProvider,
    private payrollInsuranceReportProvider: PayrollInsuranceReportProvider,
    private pnd1Provider: Pnd1Provider,
    private pnd1korProvider: Pnd1korProvider,
    private thawiProvider: ThawiProvider,
    private workmenReportProvider: WorkmenReportProvider,
    private payrollProcessThaiReportProvider: PayrollProcessThaiReportProvider,
    private banKThaiReportProvider: BanKThaiReportProvider,
    private fileTransferProvider: FileTransferProvider,
    private sfPayslipProvider: SfPayslipProvider,
    private payrollHistoryProvider: PayrollHistoryProvider,
    private sfCompanyProvider: SfCompanyProvider,
    private costCenterThaiProvider: CostCenterThaiProvider,
    private storage: Storage,
    private pnd91Api: Pnd91Api,
    private reportLoryorApi: ReportLoryorApi,
    private payrollProcessMalayReportApi: PayrollProcessMalayReportApi,
    private stdFormulaReportApi: StdFormulaReportApi,
    private bankMalayReportApi: BankMalayReportApi,
    private fileDownloaderProvider: FileDownloaderProvider,
    private socsoReportApi: SocsoReportApi,
  ) {
  }


  public getPnd1Summary(coCode, periodCode, payDate) {
    let params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getPdfpnd?filter=' + JSON.stringify(params);
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'pnd1_summary' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getPnd1SummaryNest(coCode, periodCode, payDate) {
    const params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.pnd1Provider.doSummary(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'pnd1_summary' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      }, err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getPnd1Detail(coCode, periodCode, payDate) {
    let params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getPdfPndDetail?filter=' + JSON.stringify(params);
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'pnd1_detail' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getPnd1DetailNest(coCode, periodCode, payDate) {
    const params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.pnd1Provider.doDetail(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'pnd1_detail' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      }, err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getSSOReport(coCode, periodCode, payDate) {
    let params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getPdfSso?filter=' + JSON.stringify(params);
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'Social Security 1-03' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getSSOReportNest(coCode, periodCode, payDate) {
    const params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollInsuranceReportProvider.downloadPdfSso(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Social Security 1-03' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      }, err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getRPHReport(coCode, periodCode, payDate) {
    let params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getPdfRph?filter=' + JSON.stringify(params);
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'Social Security 6-09' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getRPHReportNest(companyCode, periodCode, paydate) {
    const params = {
      companyCode,
      periodCode,
      paydate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollInsuranceReportProvider.doSSO609(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Social Security 6-09' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      }, err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getProvidentReport(coCode, periodCode, payDate) {
    let params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getPdfProvident?filter=' + JSON.stringify(params);
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getProvidentReportNew(coCode, periodCode, payDate, fullName, email, companyId) {
    let data = [];
    data.push({
      fullName: fullName,
      emailUser: email,
      sendEmail: false,
      isCordova: false,
      companyCode: coCode,
      periodCode: periodCode + '|' + moment(payDate).format('YYYY-MM-DD'),
      startdate: payDate,
      listEmp: [],
      companyId: companyId,
      // bankgroupCode: bankgroupCode
    });

    let url = LoopBackConfig.getPath() + '/api/SFPayProcessReports/PVFgenExcel';

    url += '&filter=' + encodeURIComponent(JSON.stringify(data));
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'pvf.xls');
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getProvidentReportNest(coCode, periodCode, payDate, fullName, email, companyId) {
    const data = [];
    data.push({
      fullName: fullName,
      emailUser: email,
      sendEmail: false,
      isCordova: false,
      companyCode: coCode,
      periodCode: periodCode + '|' + moment(payDate).format('YYYY-MM-DD'),
      startdate: payDate,
      listEmp: [],
      companyId: companyId,
      // bankgroupCode: bankgroupCode
    });
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollInsuranceReportProvider.downloadPVFgenExcel(JSON.stringify(data)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'pvf' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getPnd2Summary(coCode, periodCode, payDate) {
    let params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getPdfRpyAnnual?filter=' + JSON.stringify(params);
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'PND1Kor_summary' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getPnd2SummaryNest(companyCode, periodCode, paydate) {
    const params = {
      companyCode,
      periodCode,
      paydate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.pnd1korProvider.doSummary(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'PND1Kor_summary' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      }, err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getPnd2Detail(coCode, periodCode, payDate) {
    let params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getPdfRpyAnnualDetail?filter=' + JSON.stringify(params);
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'PND1Kor_detail' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getPnd2DetailNest(companyCode, periodCode, paydate) {
    const params = {
      companyCode,
      periodCode,
      paydate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.pnd1korProvider.doDetail(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'PND1Kor_detail' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      }, err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getRPYTwi(coCode, periodCode, payDate) {
    let params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getPdfRpyTwi?filter=' + JSON.stringify(params);
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, '50_RIPYTwi' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getRPYTwiNest(companyCode, periodCode, paydate) {
    const params = {
      companyCode,
      periodCode,
      paydate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.thawiProvider.doThawi(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, '50_RIPYTwi' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getWorkmenSummary(companyCode, periodCode, paydate) {
    const params = {
      companyCode,
      periodCode,
      paydate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.workmenReportProvider.doSummary(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Workmen Summary' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getWorkmenTax(companyCode, periodCode, paydate) {
    const params = {
      companyCode,
      periodCode,
      paydate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.workmenReportProvider.doTax(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Workmen Tax' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getSSCSummary(coCode, periodCode, payDate) {
    let params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getPdfSSC?filter=' + JSON.stringify(params);
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'Social Security 1-10 Summary' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getSSCSummaryNest(coCode, periodCode, payDate) {
    const params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollInsuranceReportProvider.downloadSsoSummary(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Social Security 1-10 Summary' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      }, err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getSSCDetail(coCode, periodCode, payDate) {
    let params = {
      companyCode: coCode,
      periodCode: periodCode,
      paydate: payDate,
    };
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getPdfSSCReport?filter=' + JSON.stringify(params);
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'Social Security 1-10 Detail' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getSSCDetailNest(companyCode, periodCode, paydate) {
    const params = {
      companyCode,
      periodCode,
      paydate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollInsuranceReportProvider.downloadSsoDetail(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Social Security 1-10 Detail' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      }, err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public gdJvReport(year: any, periodCode: string) {
    this.fileDownloaderProvider.createCustomProgress();
    this.costCenterThaiProvider.jvReport(year, periodCode).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'JV Report' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public payprocess(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollProcessReportProvider.downloadPayReport(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Pay Report' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadtk(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.bpjsReportProvider.downloadtk(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'BPJS TK Contribution Report' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadtksummary(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.bpjsReportProvider.downloadtksummary(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'BPJS TK Summary Report' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadks(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.bpjsReportProvider.downloadks(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'BPJS KS Contribution Report' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public payHistory(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollProcessReportProvider.downloadPayHistory(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Payroll History Report' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadBankMY(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollProcessReportProvider.donwloadbankfile(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          let extension = '';
          if (filter.bankCode === 'HLBB') {
            extension = Extension.EXCEL
          } else if (filter.bankCode === 'PBB') {
            extension = Extension.TEXT
          } else if (filter.bankCode === 'CIMB') {
            extension = Extension.TEXT
          } else if (filter.bankCode === 'MAYBANK') {
            extension = Extension.CSV;
            if (filter.hlType == 1) {
              extension = Extension.TEXT;
            }
          }
          saveAs(event.body, filter.bankCode + '.' + extension);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public dtpReport(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollProcessReportProvider.downloadDTP(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'DTP Report' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadComparison(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollProcessReportProvider.downloadComparison(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Comparison Report' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public doEmpSalaryCard(filter) {
    this.payrollProcessReportProvider.doEmpSalaryCard(filter).subscribe(
      res => {
        saveAs(res, 'Employee Salary Card' + '.' + Extension.EXCEL);
      },
      err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadPayrollHistory(params) {
    this.payrollHistoryProvider.payrollHistory(params).subscribe(
      res => {
        saveAs(res, 'TemplatePayrollHistory' + '.' + Extension.EXCEL);
      },
      err => {
        this.errorHandle(err);
      });
  }

  public downloadSptMasa(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollSptReportProvider.downloadSptMasa(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'SPT Masa' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadSptForm(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollSptReportProvider.downloadSptForm(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'SPT1721i' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadSptEFilling(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollSptReportProvider.downloadSptEFilling(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'SPT1721i' + '.' + Extension.CSV);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public doDownload1721A1(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollSptReportProvider.download1721A1(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'SPT 1721-A1' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public download1721A1All(filter) {
    this.payrollSptReportProvider.download1721A1All(filter).subscribe(
      res => {
        saveAs(res, 'E-SPT' + '.' + Extension.CSV);
      },
      err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public downBankReport(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.bankReportProvider.downBankReport(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Bank Transfer' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downBankReportTH(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.banKThaiReportProvider.downBankReportTH(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Bank Transfer' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downBankReportMY(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.bankMalayReportApi.downBankReport(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Bank Transfer' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadFormatBank(filter) {
    this.fileDownloaderProvider.createCustomProgress();
    this.bankReportProvider.downloadFormatBank(filter).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          const bankCode = JSON.parse(filter)[0].bankCode;
          const flag = JSON.parse(filter)[0].flag;

          let extension = '';
          if (bankCode == 'BRI' || (bankCode == 'MANDIRI' && flag == 1)) {
            extension = Extension.EXCEL
          } else if (bankCode == 'JENIUS' || bankCode == 'PERMATA' || bankCode == 'MCM' || (bankCode == 'MANDIRI' && flag == 2)) {
            extension = Extension.CSV
          } else if (bankCode == 'CIMB' || bankCode == 'BCA') {
            extension = Extension.TEXT
          }
          saveAs(event.body, bankCode + '.' + extension);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadFormatBankMY(filter) {
    this.bankMalayReportApi.downloadFormatBank(filter).subscribe(
      res => {
        const bankCode = JSON.parse(filter)[0].bankCode;
        let extension = '';
        switch (bankCode) {
          case 'CIMB':
            extension = Extension.TEXT;
            break;

          default:
            extension = Extension.EXCEL;
        }
        saveAs(res, bankCode + '.' + extension)
      },
      err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadComponent(filter) {
    this.payrollProcessReportProvider.downloadTemplateComponent(filter).subscribe(
      res => {
        saveAs(res, 'Template Component' + '.' + Extension.EXCEL);
      },
      err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downloadTempComponenFiltered(empStatus: any, gender: any,
    religion: string, marital: string,
    skip: any, limit: any, searchByFullname: any) {
    this.payrollProcessReportProvider.downloadTempCompoFiLtered(empStatus,
      gender, religion, marital,
      skip, limit, searchByFullname).subscribe(
        res => {
          saveAs(res, 'Template Component' + '.' + Extension.EXCEL);
        },
        err => {
          const fr = new FileReader();
          const that = this;
          fr.onload = function () {
            const res: string = this.result as string;
            that.showAlert(JSON.parse(res).message);
          };
          fr.readAsText(err.error);
        });
  }

  public downloadComponentTH(empStatus: any, gender: any,
    religion: string, marital: string,
    skip: any, limit: any, searchByFullname: any) {

    this.payrollProcessThaiReportProvider.downloadTemplateComponent(empStatus,
      gender, religion, marital,
      skip, limit, searchByFullname).subscribe(
        res => {
          saveAs(res, 'Template Component' + '.' + Extension.EXCEL);
        },
        err => {
          const fr = new FileReader();
          const that = this;
          fr.onload = function () {
            const res: string = this.result as string;
            that.showAlert(JSON.parse(res).message);
          };
          fr.readAsText(err.error);
        });
  }

  public downloadComponentMY(
    empStatus: any,
    gender: any,
    religion: string,
    marital: string,
    skip: any,
    limit: any,
    searchByFullname: any,
  ) {
    this.payrollProcessMalayReportApi.downloadTemplateComponent(
      empStatus,
      gender,
      religion,
      marital,
      skip,
      limit,
      searchByFullname,
    ).subscribe(
      res => {
        saveAs(res, 'Template Component' + '.' + Extension.EXCEL);
      },
      err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public getBankTransfer(coCode, periodCode, payDate, fullName, email, isCordova, companyId, bankCode, bankgroupCode, flag?) {
    const data = [];
    data.push({
      fullName: fullName,
      emailUser: email,
      sendEmail: false,
      isCordova: isCordova,
      companyCode: coCode,
      periodCode: periodCode + '|' + moment(payDate).format('YYYY-MM-DD'),
      startdate: payDate,
      listEmp: [],
      companyId: companyId,
      bankCode: bankCode,
      bankgroupCode: bankgroupCode,
      ...(flag && { flag }),
    });

    this.fileDownloaderProvider.createCustomProgress();
    this.banKThaiReportProvider.downloadFormatBank(JSON.stringify(data)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, bankCode + '.' + (flag == 1 ? Extension.TEXT : Extension.EXCEL));
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public downTaxTemplate(periodCode, payDate, fullName, email, companyId) {
    const data = {
      fullName: fullName,
      emailUser: email,
      sendEmail: 0,
      paydate: moment(payDate).format('YYYY-MM-DD'),
      isCordova: 0,
      periodCode: periodCode,
      companyId: companyId,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollTaxReportProvider.downTaxTemplate(JSON.stringify(data)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'TemplateTaxUpload' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getPayrollRegister(coCode, periodCode, payDate, fullName, email, isCordova, companyId, bankgroupCode) {
    let data = [];
    data.push({
      fullName: fullName,
      emailUser: email,
      sendEmail: false,
      isCordova: isCordova,
      companyCode: coCode,
      periodCode: periodCode + '|' + moment(payDate).format('YYYY-MM-DD'),
      startdate: payDate,
      listEmp: [],
      companyId: companyId,
      bankgroupCode: bankgroupCode
    });

    let url = LoopBackConfig.getPath() + '/api/SFPayProcessReports/registerPayroll';

    url += '&filter=' + encodeURIComponent(JSON.stringify(data));
    window.location.href = url
  }

  public getSsoEmpty(coCode) {
    const data = [];
    data.push({
      companyCode: coCode,
    });
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getSsoEmpty';
    url += '&filter=' + encodeURIComponent(JSON.stringify(data));
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'Social Security 9.02' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getSsoEmptyNest() {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollInsuranceReportProvider.downloadSsoEmpty().subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Social Security 9.02' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      }, err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getSsoEmptyR(coCode) {
    const data = [];
    data.push({
      companyCode: coCode,
    });
    let url = LoopBackConfig.getPath() + '/api/Pdfpnds/getSsoEmptyR';
    url += '&filter=' + encodeURIComponent(JSON.stringify(data));
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, 'Social Security 6-10' + '.' + Extension.PDF);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public getSsoEmptyRNest() {
    this.fileDownloaderProvider.createCustomProgress();
    this.payrollInsuranceReportProvider.downloadSsoEmptyR().subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Social Security 6-10' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      }, err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public sendToEmailPayslipThV2(procmtdhId) {
    this.sfPayslipProvider.sendPayslipThV2(procmtdhId).subscribe(
      res => {
        // saveAs(res, 'Download Payslip' + '.' + Extension.PDF);
        this.showAlert('Successfully Sent to Email.');
      },
      err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public getDownloadPayslipThV2(procmtdhId, download) {
    this.sfPayslipProvider.downloadPayslipThV2(procmtdhId, download).subscribe(res => {
      saveAs(res, 'Download Payslip' + '.' + Extension.PDF);
    }, err => {
      const fr = new FileReader();
      const that = this;
      fr.onload = function () {
        const res: string = this.result as string;
        that.showAlert(JSON.parse(res).message);
      };
      fr.readAsText(err.error);
    });
  }

  public async getDownloadPayslip(procmtdhId, download) {
    const clang: string = await this.storage.get('language')
    this.sfPayslipProvider.downloadPayslip(procmtdhId, download, clang.toUpperCase()).subscribe(res => {
      saveAs(res, 'Download Payslip' + '.' + Extension.PDF);
    }, err => {
      const fr = new FileReader();
      const that = this;
      fr.onload = function () {
        const res: string = this.result as string;
        that.showAlert(JSON.parse(res).message);
      };
      fr.readAsText(err.error);
    })
  }

  public gdDownloadPaySlipSF6(procmtdh_id) {
    return new Promise(async (resolve, reject) => {
      try {
        const clang: string = await this.storage.get('language')
        this.sfPayslipProvider.getPaySlipSF6({ procmtdh_id, clang: clang.toUpperCase() })
          .subscribe(res => {
            saveAs(res, 'Payslip Report' + '.' + Extension.PDF);
            resolve(res);
          }, err => {
            const fr = new FileReader();
            const that = this;
            fr.onload = function () {
              const res: string = this.result as string;
              that.showAlert(JSON.parse(res).message);
            };
            fr.readAsText(err.error);
          })
      } catch (error) {
        reject(error);
      }
    })
  }

  public gdDownloadPayslipThAll(params: any) {
    this.fileDownloaderProvider.createCustomProgress();
    this.sfPayslipProvider.postDownloadPayslipThAll(params).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'Download All Payslip' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
        console.log('err : ', err);
      });
  }

  public downloadExcelPayReg(fileName) {
    let filter = JSON.parse(`{"filenames":"${fileName}"}`);
    let url = LoopBackConfig.getPath() + '/api/SFPayProcessReports/downloadExcel';
    url += '&filter=' + JSON.stringify(filter);
    window.location.href = url
    // window.open(url, '_system');
  }

  public downloadExcelPayRegNest(fileName: string) {
    this.payrollRegisterReportProvider.downloadRegisterPayroll(fileName).subscribe(
      res => {
        saveAs(res, fileName + '.' + Extension.EXCEL);
      },
      err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      });
  }

  public AutomaticTransferTMB(fileName) {
    let url = LoopBackConfig.getPath() + '/api/bankFileStorages/excelTemp/download/' + fileName + '';
    this.downloadFromWeb(url).subscribe(
      res => {
        saveAs(res, fileName);
      }, err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).error.message);
        };
        fr.readAsText(err.error);
      }
    );
  }

  public AutomaticTransferTMBNest(fileName) {
    this.fileTransferProvider.SftpTMB(fileName).subscribe(
      res => {
        this.showAlert(res.message);
      },
      err => {
        this.showAlert(err.message);
      }
    );
  }

  public downloadCsvByFileName(fileName: string) {
    this.sfCompanyProvider.downloadFileByName(fileName).subscribe(
      res => {
        saveAs(res, fileName + '.' + Extension.CSV);
      },
      err => {
        this.errorHandle(err);
      });
  }

  public gdDownloadSPTSF6(taxdata) {
    return new Promise((resolve, reject) => {
      const filenameDownload = taxdata.filenameDownload;
      const procytdhid = taxdata.procytdh_id;
      this.sfPayslipProvider.getSPTSF6(procytdhid).subscribe(res => {
        saveAs(res, filenameDownload + '.' + Extension.PDF);
        resolve(true);
      }, err => {
        reject(err);
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      })
    })
  }

  public genPnd91Nest(companyCode, periodCode, paydate): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      const params = {
        companyCode,
        periodCode,
        paydate,
      };

      this.pnd91Api.genPnd91(JSON.stringify(params)).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      )
    })
  }

  public getgenLy03(companyCode, periodCode, paydate) {
    const params = {
      companyCode,
      periodCode,
      paydate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.reportLoryorApi.genLy03(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'loryor01' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getZipFile(response, fileName) {
    this.pnd91Api.getZipFile(JSON.stringify(response)).subscribe(
      res => {
        saveAs(res, fileName + '.' + Extension.ZIP);
      },
      err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public getgenLy01(companyCode, periodCode, paydate) {
    const params = {
      companyCode,
      periodCode,
      paydate,
    };
    this.fileDownloaderProvider.createCustomProgress();
    this.reportLoryorApi.genLy01(JSON.stringify(params)).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'loryor01' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public downloadEPFReportMalaysia(companyCode, periodCode, paydate) {
    const params = {
      companyCode,
      periodCode,
      paydate,
    };

    this.reportLoryorApi.genLy03(JSON.stringify(params)).subscribe(
      res => {
        saveAs(res, 'loryor01' + '.' + Extension.PDF);
      },
      err => {
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public downloadTaxCalculation(params: RequestDownloadFormulaDto) {
    this.fileDownloaderProvider.createCustomProgress();
    this.stdFormulaReportApi.downloadformula(params).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'STD Formula Report' + '.' + Extension.EXCEL);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  public socsoForm8A(params: RequestExportSocsoPDF) {
    this.fileDownloaderProvider.createCustomProgress();
    this.socsoReportApi.exporttopdf(params).subscribe(
      (event: HttpEvent<any>) => {
        if (event.type === HttpEventType.DownloadProgress) {
          const percentageProgress = Math.round(100 * event.loaded / event.total);
          this.fileDownloaderProvider.loadingProgress(percentageProgress);
        } else if (event.type === HttpEventType.Response) {
          saveAs(event.body, 'SOCSO eForm 8A' + '.' + Extension.PDF);
          this.fileDownloaderProvider.removeCustomProgress();
        }
      },
      err => {
        this.fileDownloaderProvider.removeCustomProgress();
        const fr = new FileReader();
        const that = this;
        fr.onload = function () {
          const res: string = this.result as string;
          that.showAlert(JSON.parse(res).message);
        };
        fr.readAsText(err.error);
      }
    )
  }

  private downloadFromWeb(url: string) {
    return this.http.get(url, { responseType: 'blob' as 'json' });
  }

  private showAlert(message): void {
    this.alertService.createMola(message).then(() => {
    })
  }

  private errorHandle(err) {
    const fr = new FileReader();
    const that = this;
    fr.onload = function () {
      const res: string = this.result as string;
      that.showAlert(JSON.parse(res).message);
    };
    fr.readAsText(err.error);
  }
}



// WEBPACK FOOTER //
// ./src/providers/gd-payroll-report/gd-payroll-report.ts